module.exports = __webpack_public_path__ + "img/previous.c4ef03b4.svg";